/*
 * @Description: 推荐单
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-01-06 15:37:26
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-11 16:50:57
 */
import request from '../../utils/request'
import server from './config'
export default {
  /**
   * 推荐单详情
   */
  recommendDetail:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/prescription/1/getOtcInfoDetailById`,
      method: 'post',
      data
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/modules/recommend.js